
// export const BASE_URL = "https://website-backend.kaaruj.cloud/";
export const BASE_URL = "https://kaaruj-backend.sandbox.payinpos.com/";
